import { render, staticRenderFns } from "./HonorBoard.vue?vue&type=template&id=5ddee998&scoped=true&"
import script from "./HonorBoard.vue?vue&type=script&lang=js&"
export * from "./HonorBoard.vue?vue&type=script&lang=js&"
import style0 from "./HonorBoard.vue?vue&type=style&index=0&id=5ddee998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddee998",
  null
  
)

export default component.exports